export const isLocal = (): boolean => {
  const path = location.href;
  return path.includes('local.') || path.includes('localhost');
};

export const isProd = (): boolean => {
  const path = location.href;
  return path.includes('stg.') ||
    path.includes('dev.') ||
    path.includes('local.') ||
    path.includes('localhost')
    ? false
    : true;
};

export const envString = (): string => {
  const path = location.href;
  if (path.includes('stg.')) return 'stg';
  else if (path.includes('dev.')) return 'dev';
  else if (path.includes('local.') || path.includes('localhost'))
    return 'local';
  else return 'prod';
};

export const isOnPremises = (): boolean => {
  return process.env.NEXT_PUBLIC_ON_PREMISES !== undefined;
};
